module.exports = __webpack_public_path__ + "img/img3.7486a4c6.svg";